<template>
   <b-button
      @click="() => { modalState = true }"
      size="sm"
      :disabled="disabled"
      :variant="(httpRequestInProgress) ? 'success': 'primary'"
      block
   ><!-- button -->
      <span v-if="httpRequestInProgress">
      <b-spinner
         type="grow"
         label="Loading..."
         small
      ></b-spinner>
      </span>
      <span v-else>Testkäufer blacklisten</span>
      <b-modal id="modal-blacklist-testbuyer"
         v-model="modalState"            
         title="Testkäufer blacklisten"
         @ok="handleOk"
         cancel-title="abbrechen"
         size="md"
      >
      {{ message }}
      </b-modal>
   </b-button>
</template>
<script>
export default {
   props: ['address','authorization' ],
   data() {
      return {
          modalState: false,
          disabled: false,
          httpRequestInProgress: false,
          message: 'Wollen sie diesen Käufer blacklisten?',
      };
   },
   methods: {
     handleOk(bvModalEvt) {
       bvModalEvt.preventDefault();
       this.submitAddressId();
     },
     submitAddressId() {
        this.modalState = true;
         this.disabled = true;
         this.httpRequestInProgress = true;
         axios.post('/customerorder/action/blacklist_testbuyer', {
           address: this.address
         }).then((res) => {
            this.modalState = false;
            this.httpRequestInProgress = false;
         }).catch((error) => {
            this.disabled = false;
            this.httpRequestInProgress = false;
            this.message = 'Fehler beim blacklisten des Testkäufers: ' + error.response.data.message;
            console.error(error);
         });
      }
   },
}
</script>
